import Reveal from "@/components/home/Reveal";
import { Banknote, Lock, Users, CalendarX, Bike, MapPinned, Lightbulb } from "lucide-react";

const RULES = [
  { icon: Banknote, title: "No tocamos tu dinero.", text: "El pago de tus clientes entra directo a tu cuenta. Nosotros no captamos ni retenemos ni un peso." },
  { icon: Lock, title: "No pedimos datos de tu tarjeta.", text: "No recogemos información bancaria. Ni para la prueba, ni después." },
  { icon: Users, title: "Tus clientes son tuyos.", text: "No nos quedamos con su base de datos. Cero intermediarios." },
  { icon: CalendarX, title: "Sin plazos forzosos.", text: "Sin contratos amarrados. Te quedas porque te funciona, no porque te obligamos." },
  { icon: Bike, title: "App de reparto exclusiva para tu equipo.", text: "Solo tu personal la usa. No es para repartidores externos." },
  { icon: MapPinned, title: "Tu propia identidad con Google Business Sync.", text: "Tu ficha se ve pro con tu logo, menú y fotos sincronizadas en automático. La integras a tus páginas de Facebook e Instagram." },
  { icon: Lightbulb, title: "Curva de aprendizaje CERO.", text: "Tu cliente no descarga nada nuevo. Pide por WhatsApp, la app que ya usa todos los días. Si sabe mandar un \"Hola\", ya sabe pedirte." },
];

export const YourRules = () => (
  <section className="mt-section bg-brand-carbon text-white relative overflow-hidden" data-testid="rules-section">
    <div className="absolute inset-0 opacity-[0.07] pointer-events-none" style={{ backgroundImage: "radial-gradient(#FF6612 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
    <div className="mt-container relative">
      <Reveal className="max-w-2xl">
        <p className="text-brand-orange font-semibold text-sm uppercase tracking-wider">#MenuThere</p>
        <h2 className="mt-2 text-3xl sm:text-4xl lg:text-5xl leading-tight">Tu negocio, <span className="text-brand-orange">tus reglas.</span></h2>
        <p className="mt-4 text-base md:text-lg text-gray-300">Con MenuThere el control es 100% tuyo. Es la infraestructura digital que convierte tu Perfil de Google y tu WhatsApp en tu propio canal de pedidos sin comisión.</p>
      </Reveal>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {RULES.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={i * 70} className={`rounded-2xl bg-white/[0.06] border border-white/10 p-6 hover:bg-white/[0.1] transition-colors ${i === RULES.length - 1 ? "sm:col-span-2 lg:col-span-1" : ""}`} data-testid={`rule-card-${i + 1}`}>
            <div className="w-11 h-11 rounded-xl bg-brand-orange/20 text-brand-orange grid place-items-center"><Icon className="w-5 h-5" /></div>
            <h3 className="mt-4 text-lg leading-snug">{title}</h3>
            <p className="mt-2 text-sm text-gray-300 leading-relaxed">{text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default YourRules;
